import { Stack } from "@mui/material";
import { useEffect, useState } from "react";

import SearchBar from "./components/SearchBar";
import { SearchRequest, useSearchCustomer } from "../../api/pps";
import CustomerDataGrid from "../../components/pps/customerDataGrid/CustomerDataGrid";
import { usePermissionStore } from "../../stores/permissionStore";
import { useCustomerStore, useSetCustomerStore } from "../../stores/ppsStore";

const Pps = () => {
  const [isSearch, setIsSearch] = useState(false);
  const customerStore = useCustomerStore();
  const setCustomerStore = useSetCustomerStore();

  const [request, setRequest] = useState<SearchRequest>({
    pagination: {
      currentPage: 1,
      pageSize: 12,
    },
    permission_Token: usePermissionStore.getState().permissionToken ?? "",
  });

  const {
    data: dataCustomer,
    isFetching,
    refetch,
  } = useSearchCustomer(request, isSearch);

  useEffect(() => {
    if (dataCustomer) {
      setCustomerStore(dataCustomer.data);
    }
  }, [dataCustomer]);

  return (
    <Stack paddingX={4}>
      <SearchBar
        request={request}
        setRequest={setRequest}
        setIsSearch={setIsSearch}
        refetch={refetch}
      />
      <CustomerDataGrid
        onPageChange={page => {
          setRequest({
            ...request,
            pagination: { ...request.pagination, currentPage: page },
          });
        }}
        data={customerStore}
        loading={isFetching}
        refetch={refetch}
      />
    </Stack>
  );
};

export default Pps;
